import React from 'react';
import block from 'bem-cn-lite';
import './DeliveryDays.scss';
import {Text, Tooltip} from '@gravity-ui/uikit';
import {useMediaQuery} from 'react-responsive';

const b = block('delivery-days');

export interface DeliveryDaysProps {
    value: number;
    className?: string;
    maxValue?: number;
    oldValue?: number;
}

export const DeliveryDays: React.FC<DeliveryDaysProps> = (props) => {
    const isSmallScreen = useMediaQuery({query: '(max-width: 1150px)'});
    const showRange = props.maxValue !== undefined;
    const hasOldValue = props.oldValue !== undefined;

    const content = (
        <div className={b() + ' ' + (props.className || '')}>
            {hasOldValue ? (
                // Отображение нового и старого значения
                <>
                    <Text
                        variant={'body-2'}
                        color={'warning'}
                        style={
                            showRange
                                ? {
                                      textDecoration: 'underline',
                                      textDecorationStyle: 'wavy',
                                      textUnderlineOffset: '25%',
                                      textDecorationThickness: '0%'
                                  }
                                : undefined
                        }
                    >
                        {showRange ? `${props.value}-${props.maxValue}` : `${props.value}`} дн.
                    </Text>
                    <Text color={'secondary'} variant={'caption-2'}>
                        <s>{props.oldValue} дн.</s>
                    </Text>
                </>
            ) : (
                // Обычное отображение
                <Text
                    variant={'body-2'}
                    style={
                        showRange
                            ? {
                                  textDecoration: 'underline',
                                  textDecorationStyle: 'wavy',
                                  textUnderlineOffset: '25%',
                                  textDecorationThickness: '0%'
                              }
                            : undefined
                    }
                >
                    {showRange ? `${props.value}-${props.maxValue}` : `${props.value}`} дн.
                </Text>
            )}
        </div>
    );

    if (showRange) {
        return (
            <Tooltip
                content={
                    <Text variant={'body-1'}>Здесь везём издалека. Указан min и max срок</Text>
                }
                contentClassName={b('delivery-days-tooltip')}
                className={b('delivery-days-tooltip-container')}
                placement={isSmallScreen ? 'top-end' : 'top'}
                openDelay={0}
                closeDelay={0}
                disabled={false}
            >
                {content}
            </Tooltip>
        );
    }

    return content;
};
